<template>
    <div
        :class="[classNames + '-upload-img-list-item', { [classNames + '-is-required']: !value && item.required && isSubmitFlag }]">
        <div :class="classNames + '-upload-img-list-item-img'"
            :style="{ 'width': item.width + 'px', height: item.height + 'px' }">
            <el-image :class="classNames + '-upload-img'" :src="value"
                v-if="value" :preview-src-list="previewSrcList"
                ref="preview" :style="{ 'width': item.width + 'px', height: item.height + 'px' }"/>
            <div class="image-slot" @[clickType]="editAvatarUrl(item.prop)" v-else>
                <template v-if=" typeof item.process === 'number'">
                    <el-progress type="circle" :percentage="item.process" :width="100">
                    </el-progress>
                </template>
                <i class="el-icon-plus" v-else></i>
            </div>
            <div class="upload_con_replace" v-if="value">
                <el-tooltip content="重新上传" placement="top" effect="light" v-if="!is_disabled">
                    <i class="el-icon-plus" @click="editAvatarUrl(item.prop)"></i>
                </el-tooltip>
                <el-tooltip content="删除" placement="top" effect="light" v-if="!is_disabled">
                    <i class="el-icon-delete" @click="deleteItem(item.prop)"></i>
                </el-tooltip>
            </div>
        </div>
        <el-tooltip :content="item.desc" :popper-class="classNames + '-tooltip'"
            :placement="flexDirection === 'column' ? 'right' : 'top'">
            <span v-if="showTitle" style="color:#409EFF;line-height:18px;width: 170px;">{{ item.title }}</span>
        </el-tooltip>
        <span v-if="item.titFlag">{{ item.tit }}</span>
        <span class="error-title"
            v-show="!value && item.required && isSubmitFlag">请上传{{ item.tit }}</span>
        <template v-if="value">
            <slot name="content"></slot>
        </template>
        <upload-file ref="uploadFile" uploadType="img" :accept="['.jpg','.png','.jpeg']" :multiple="false" uploadSize="5mb" :isAddSucaiFlag="false" @beforeUpload="beforeUpload" @change="uploadProgress" @uploadSucess="uploadSucess"></upload-file>
    </div>
</template>
<script>
	import axios from 'axios'
	import { getBaseUrl } from '@/utils/baseUrl.js'
import uploadFile from '@/components/newUpload/upload.vue'
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        is_disabled: {
            type: Boolean,
            default: false
        },
		showTitle: {
		    type: Boolean,
		    default: true
		},
        item: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isSubmitFlag: {
            type: Boolean,
            default: false
        },
        flexDirection: {
            type: String,
            default: 'row'
        },
    },
    data() {
        return {
        }
    },
    components: {
        'upload-file': uploadFile,
    },
    computed: {
        clickType() {
            return !this.is_disabled && !this.item.isDisabledEdit ? 'click' : ''
        }
    },
    data() {
        return {
            classNames: 'page',
            previewSrcList: [],
			FormData: {}
        }
    },
    methods: {
        editAvatarUrl() {
            this.$refs.uploadFile.uploadFile()
        },
        deleteItem() {
            this.$set(this.item, 'process', '')
            this.$emit('input',  '')
            this.$emit('delete')
        },
        preview(src) {
            this.previewSrcList = [src]
            const doms = this.$refs['preview']
            setTimeout(() => {
                doms.clickHandler()
            }, 0)
        },
        beforeUpload(list) {
            this.$emit('input',  '')
            this.$set(this.item, 'process',0)
            this.$set(this.item, 'isDisabledEdit',true)
            this.$forceUpdate()
        },
        uploadProgress(list) {
            this.$set(this.item, 'process', list[0].process)
            console.log(this.item.process)
        },
        uploadSucess(list) {
            this.$set(this.item, 'isDisabledEdit',false)
            this.$emit('input', list[0].url)
			this.uploadFileDouyin(list[0].file) 
        },
		uploadFileDouyin(file){
			const uploadUrl = getBaseUrl() + '/message/tool/client_upload'
			const uploadHeaders = {
				'Content-Type': 'application/x-www-form-urlencoded',
				token: localStorage.getItem('token') || ''
			}
			const formData = new FormData()
			formData.append('image', file)
			axios.post(uploadUrl,formData,{
				headers: uploadHeaders
			}).then((res)=>{
				if(res.status == 200){
					if(res.data.code ==0 && res.data.data.media_id){
						this.$emit('media_id', res.data.data.media_id)
					} else {
						this.$message({
						    type: 'error',
						    message:'上传失败',
						    duration: 3000
						})
					}
				}
			})
		}
    }
}
</script>
<style lang="less" >
    @classNames: page;
    .@{classNames}-tooltip {
        width: 200px;
    }
.@{classNames}-upload-img-list-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    &.page-is-required {
        padding-bottom: 18px;

        .page-upload-img-list-item-img {
            box-sizing: border-box;
            border: 1px solid #F56C6C;
        }
    }

    &:not(:last-child) {
        margin-right: 24px;
    }

    .error-title {
        color: #F56C6C;
        font-size: 12px;
        position: absolute;
        left: 50%;
        bottom: 0;
        white-space: nowrap;
        transform: translateX(-50%);
    }

    >span {
        color: #bdb2c8;
        font-size: 14px;
        line-height: 16px;
        margin-top: 6px;
    }

    .@{classNames}-upload-img-list-item-img {
        position: relative;
        overflow: hidden;

        .upload_con_replace {
            background-color: rgba(0, 0, 0, .49);
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: translateY(100%);
            transition: all 200ms linear;

            i {
                // padding: 9px 15px;
                color: #fff;
                // background-color: #4e70f2;
                // border-color: #4e70f2;
                // line-height: 12px;
                font-size: 20px;
                cursor: pointer;

                &:not(:last-child) {
                    margin-right: 6px;
                }
            }
        }

        &:hover {
            .upload_con_replace {
                transform: translateY(0%);
            }
        }
    }

    .@{classNames}-upload-img {
        width: 170px;
        height: 108px;
        position: relative;
    }

    .image-slot {
        background-color: #f3f4f9;
        color: #c7cada;
        width: 100%;
        height: 100%;
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.is_disabled {
    position: relative;

    .@{classNames}_disabled {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0px;
        right: 0;
        z-index: 100;
    }
}
</style>
